export default {
  en: {
    headerTitle: 'Idiom',
    notFoundTitle: 'Idiom not found',
    notFoundMessage: 'This idiom no longer exists — it may have been removed or renamed.',
    notFoundRetryLabel: 'Go home',
    translationLabel: 'Meaning',
    exampleLabel: 'Example',
    startButton: 'Start conversation',
    loadingSr: 'Loading idiom',
  },
  ru: {
    headerTitle: 'Идиома',
    notFoundTitle: 'Идиома не найдена',
    notFoundMessage: 'Такой идиомы больше нет — возможно, её убрали или переименовали.',
    notFoundRetryLabel: 'На главную',
    translationLabel: 'Значение',
    exampleLabel: 'Пример',
    startButton: 'Начать диалог',
    loadingSr: 'Загружаем идиому',
  },
  de: {
    headerTitle: 'Idiom',
    notFoundTitle: 'Idiom nicht gefunden',
    notFoundMessage: 'Dieses Idiom existiert nicht mehr — es wurde vielleicht entfernt oder umbenannt.',
    notFoundRetryLabel: 'Zur Startseite',
    translationLabel: 'Bedeutung',
    exampleLabel: 'Beispiel',
    startButton: 'Dialog starten',
    loadingSr: 'Idiom wird geladen',
  },
  pt: {
    headerTitle: 'Expressão',
    notFoundTitle: 'Expressão não encontrada',
    notFoundMessage: 'Essa expressão não existe mais — talvez tenha sido removida ou renomeada.',
    notFoundRetryLabel: 'Ir para o início',
    translationLabel: 'Significado',
    exampleLabel: 'Exemplo',
    startButton: 'Iniciar diálogo',
    loadingSr: 'Carregando expressão',
  },
  fr: {
    headerTitle: 'Expression',
    notFoundTitle: 'Expression introuvable',
    notFoundMessage: 'Cette expression n’existe plus — elle a peut-être été supprimée ou renommée.',
    notFoundRetryLabel: 'Retour à l’accueil',
    translationLabel: 'Signification',
    exampleLabel: 'Exemple',
    startButton: 'Lancer le dialogue',
    loadingSr: 'Chargement de l’expression',
  },
  es: {
    headerTitle: 'Modismo',
    notFoundTitle: 'Modismo no encontrado',
    notFoundMessage: 'Este modismo ya no existe — puede que se haya eliminado o renombrado.',
    notFoundRetryLabel: 'Ir al inicio',
    translationLabel: 'Significado',
    exampleLabel: 'Ejemplo',
    startButton: 'Iniciar diálogo',
    loadingSr: 'Cargando modismo',
  },
};
